import React from 'react'
import { SkeletonBox, withSkeleton } from 'react-zero-skeleton'

const hidden = { opacity: 0, pointerEvents: 'none', userSelect: 'none' }

export function DashboardContentSkeletonInner() {
  return (
    <>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: 16,
          marginBottom: 24,
        }}
      >
        {Array.from({ length: 4 }).map((_, index) => (
          <SkeletonBox
            key={`stat-${index}`}
            style={{ height: 96, borderRadius: 8, padding: 16, backgroundColor: '#fff' }}
          >
            <div style={{ ...hidden, height: 64 }}>Stat card</div>
          </SkeletonBox>
        ))}
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 2fr) minmax(0, 1fr)',
          gap: 16,
        }}
      >
        <SkeletonBox style={{ height: 320, borderRadius: 8, padding: 16, backgroundColor: '#fff' }}>
          <div style={{ ...hidden, height: 288 }}>Main chart</div>
        </SkeletonBox>
        <SkeletonBox style={{ height: 320, borderRadius: 8, padding: 16, backgroundColor: '#fff' }}>
          <div style={{ ...hidden, height: 288 }}>Side chart</div>
        </SkeletonBox>
      </div>
    </>
  )
}

function AppShellSkeletonBase() {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f8f9fa' }}>
      <SkeletonBox
        style={{
          width: 256,
          minHeight: '100vh',
          flexShrink: 0,
          backgroundColor: '#3c4b64',
          padding: '16px 12px',
        }}
      >
        <div style={{ ...hidden, height: 48, marginBottom: 24 }}>Logo</div>
        {Array.from({ length: 10 }).map((_, index) => (
          <div key={`nav-${index}`} style={{ ...hidden, height: 32, marginBottom: 8 }}>
            Nav item
          </div>
        ))}
      </SkeletonBox>

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <SkeletonBox
          style={{
            height: 56,
            backgroundColor: '#fff',
            borderBottom: '1px solid #ebedef',
            padding: '0 24px',
          }}
        >
          <div style={{ ...hidden, height: 24 }}>Header</div>
        </SkeletonBox>

        <div style={{ flex: 1, padding: 24 }}>
          <DashboardContentSkeletonInner />
        </div>
      </div>
    </div>
  )
}

const AppShellSkeleton = withSkeleton(AppShellSkeletonBase)

const DashboardContentSkeletonBase = () => (
  <div style={{ padding: 24 }}>
    <DashboardContentSkeletonInner />
  </div>
)

const DashboardContentSkeleton = withSkeleton(DashboardContentSkeletonBase)

export default function AppShellSkeletonFallback() {
  return <AppShellSkeleton hasSkeleton isLoadingSkeleton />
}

export function DashboardContentSkeletonFallback() {
  return <DashboardContentSkeleton hasSkeleton isLoadingSkeleton />
}
